// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__H99x_","header":"styles_header__HH4yv","action":"styles_action__IJZXH","resume":"styles_resume__3Phqq","startOver":"styles_startOver__3UB9t"};